import { Component, Vue } from 'vue-property-decorator';
import InputSelect from '@/components/inputs/InputSelect/InputSelect.vue';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputRadioButton from '@/components/inputs/InputRadioButton/InputRadioButton.vue';
import { AnswerChoices } from '@/models/VariousEnum';
import { QuestQuestion } from '@/models/QuestQuestion';
import { SelectOptionDTO } from '@/models/SelectOptionDTO';
import { QuestionnaireDTO } from '@/models/QuestionnaireDTO';
import QuestionnaireService from '@/services/questionnaire.service';
import QuestIdentity from '@/views/QuestIdentity/QuestIdentity.vue';
import QuestAddress from '@/views/QuestAddress/QuestAddress.vue';
import QuestDoctor from '@/views/QuestDoctor/QuestDoctor.vue';
import QuestInsurance from '@/views/QuestInsurance/QuestInsurance.vue';
import QuestQuestions from '@/views/QuestQuestions/QuestQuestions.vue';
import RenounceButton from '@/components/RenounceButton/RenounceButton.vue';

@Component({
  components: {
    InputSelect,
    InputText,
    InputRadioButton,
    QuestIdentity,
    QuestAddress,
    QuestDoctor,
    QuestInsurance,
    QuestQuestions,
    RenounceButton,
  },
})
export default class QuestRecap extends Vue {
  public partId: number | undefined;
  public questionnaire: QuestionnaireDTO = {} as QuestionnaireDTO;
  public questions: QuestQuestion = {} as QuestQuestion;
  public readonly: boolean = true;
  public answerChoices: any = AnswerChoices;
  public selectChoices: SelectOptionDTO[] = [];
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;

  protected mounted() {
    this.partId = Number(this.$route.params.partId);
    // this.fetchQuestionnaire(this.partId);
    this.questionnaire = this.$store.state.questionnaire;
  }

  /**
   * Fetch the questionnaire data with the service
   * @param partId The participant ID
   */
  protected fetchQuestionnaire(partId: number) {
    QuestionnaireService.fetchQuestionnaire(partId, null)
      .then((response) => {
        this.questionnaire = response as QuestionnaireDTO;
        this.$store.commit('setQuestionnaire', response)
        this.questions = new QuestQuestion(this.questionnaire.questions);
        this.$store.commit('setQuestionnaireQuestions', response.questions)
      });
  }

  protected onSubmit() {
    QuestionnaireService.confirm(this.partId!)
      .then(() => {
        this.$router.push({
          name: 'confirmation',
          params: {
            screening: this.$route.params.screening,
          },
        });
      });
  }

  protected onQuit() {
    this.$router.push({
      name: 'overview',
      params: {
        screening: this.$route.params.screening,
        partId: String(this.partId),
      },
    });
  }
}
